export const UserAllListSuccess = 'ALL_USER_LIST_SUCCESS';
export const UserListSuccess = 'USER_LIST_SUCCESS';
export const UserAddedSuccess = 'USER_ADD_SUCCESS';
export const ClearUserData = 'CLEAR_USER_DATA';

export function setAllUserListAction(data) {
  return {
    type: UserAllListSuccess,
    payload: data,
  };
}

export function setUserListAction(data) {
  return {
    type: UserListSuccess,
    payload: data,
  };
}

export function setUserAddAction(data) {
  return {
    type: UserAddedSuccess,
    payload: data,
  };
}

export function setClearUserData() {
  return {
    type: ClearUserData,
  };
}
